import logo from '../../assets/logo.svg';

export default function AppShell({ user, profile, onLogout, page, onNavigate, children, showBadge, showHomeBadge }) {
  return (
    <div className="app-shell">
      <header className="app-header">
        <div className="app-header-logo">
          <img src={logo} alt="Clube do Eu" />
          <span className="app-header-logo-text">Clube do Eu</span>
        </div>

        <button
          className={`profile-btn ${page === 'profile' ? 'active' : ''}`}
          onClick={() => onNavigate('profile')}
          title="Perfil"
          aria-label="Perfil"
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="8" r="4" />
            <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
          </svg>
        </button>
      </header>

      <main className="app-main">
        {children}
      </main>

      <nav className="bottom-nav">
        {/* Hoje — house outline */}
        <button
          className={`bottom-nav-btn ${page === 'home' ? 'active' : ''}`}
          onClick={() => onNavigate('home')}
          aria-label="Hoje"
        >
          <div className="nav-icon-wrap">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 9.5L12 3l9 6.5V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.5z" />
              <polyline points="9 21 9 13 15 13 15 21" />
            </svg>
          </div>
          <span>Hoje</span>
        </button>

        {/* Desafios — star outline */}
        <button
          className={`bottom-nav-btn ${page === 'detox' ? 'active' : ''}`}
          onClick={() => onNavigate('detox')}
          aria-label="Desafios"
        >
          <div className="nav-icon-wrap">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
            </svg>
          </div>
          <span>Desafios</span>
        </button>

        {/* YouTube */}
        <button
          className={`bottom-nav-btn ${page === 'youtube' ? 'active' : ''}`}
          onClick={() => onNavigate('youtube')}
          aria-label="Canal YouTube"
        >
          <div className="nav-icon-wrap" style={{ position: 'relative' }}>
            <div className="youtube-circle-outline">
              <svg width="22" height="16" viewBox="0 0 28 20">
                <rect width="28" height="20" rx="5" fill="#FF0000" />
                <polygon points="10,4 10,16 21,10" fill="white" />
              </svg>
            </div>
            {showBadge && <span className="nav-badge" />}
          </div>
          <span>YouTube</span>
        </button>

        {/* Pra Você — coração */}
        <button
          className={`bottom-nav-btn ${page === 'paravoce' ? 'active' : ''}`}
          onClick={() => onNavigate('paravoce')}
          aria-label="Pra Você"
        >
          <div className="nav-icon-wrap" style={{ position: 'relative' }}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
            </svg>
            {showHomeBadge && <span className="nav-badge" />}
          </div>
          <span>Pra Você</span>
        </button>

        {/* Comunidade — dois círculos/pessoas sobrepostos */}
        <button
          className={`bottom-nav-btn ${page === 'community' ? 'active' : ''}`}
          onClick={() => onNavigate('community')}
          aria-label="Comunidade"
        >
          <div className="nav-icon-wrap">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
          </div>
          <span>Comunidade</span>
        </button>
      </nav>
    </div>
  );
}
